var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefreshIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#refreshIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#6A7682",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M.667 2.667v4m0 0h4m-4 0L3.76 3.76A6 6 0 0 1 13.66 6m1.674 7.334v-4m0 0h-4m4 0L12.24 12.24A6 6 0 0 1 2.34 10"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "refreshIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export { SvgRefreshIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/refreshIcon.555997fd838d396c3634bc2258936652.svg";